const MODAL_BACKDROP_CLASSES = [
  'modal-overlay',
  'shortcuts-overlay',
  'global-search-overlay',
  'support-modal-overlay',
  'enterprise-info-overlay',
  'issues-modal-backdrop',
  'issue-evidence-preview-backdrop',
  'edit-cycle-overlay',
  'details-overlay',
  'milestone-form-overlay'
];

function isModalBackdrop(target) {
  if (!(target instanceof HTMLElement)) return false;
  return MODAL_BACKDROP_CLASSES.some((className) => target.classList.contains(className));
}

function preventBackdropClose(event) {
  if (!isModalBackdrop(event.target)) return;
  event.preventDefault();
  event.stopPropagation();

  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }
}

export function installModalBackdropCloseGuard() {
  document.addEventListener('click', preventBackdropClose, true);
}

